var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isEmpty)?_c('div',{ref:"chartWrap",staticClass:"chart-wrap"}):_c('div',{staticClass:"empty-box"},[_vm._v("暂无数据")])
}
var staticRenderFns = []

export { render, staticRenderFns }